import { i18n } from '@/plugins/i18n'
// import StatusColumn from './../components/status-column'
// import UserLevelColumn from './../components/user-level-column'

// const statusTemplate = (row, index, datatable) => {
//     let template = new StatusColumn({
//         props: {
//             row,
//             index,
//             datatable,
//         },
//         i18n,
//     })
//
//     template.row = row
//     template.index = index
//     template.datatable = datatable
//
//     return template.$mount().$el
// }
// const userLevelTemplate = (row, index, datatable) => {
//     let template = new UserLevelColumn({
//         props: {
//             row,
//             index,
//             datatable,
//         },
//         i18n,
//     })
//
//     template.row = row
//     template.index = index
//     template.datatable = datatable
//
//     return template.$mount().$el
// }

export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 50,
        type: 'number',
        selector: false,
        textAlign: 'center',
    },
    {
        field: 'phone',
        title: i18n.t('label.phone'),
        sortable: true,
        width: 90,
        textAlign: 'center',
    },
    {
        field: 'fullname',
        title: i18n.t('label.full_name'),
        sortable: true,
        width: 80,
        textAlign: 'center',
        template(row) {
            if (!row.user_id) return row.fullname || ''
            return `<a href="/users/${row.user_id}/details" target="_blank">${row.fullname || row.user_id}</a>`
        },
    },
    {
        field: 'type',
        title: i18n.t('label.type'),
        sortable: false,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'pattern_name',
        title: i18n.t('label.pattern_name'),
        sortable: false,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'status_code',
        title: i18n.t('label.status_code'),
        sortable: false,
        width: 80,
        textAlign: 'center',
        template(row) {
            const status = String(row.status_code || '');
            const firstDigit = status.charAt(0);

            let badgeClass = 'badge badge-secondary';

            switch (firstDigit) {
                case '2':
                    badgeClass = 'badge badge-success';
                    break;

                case '3':
                    badgeClass = 'badge badge-info';
                    break;

                case '4':
                    badgeClass = 'badge badge-warning';
                    break;

                case '5':
                    badgeClass = 'badge badge-danger';
                    break;
            }

            return `
            <span class="${badgeClass}">
                ${status}
            </span>
        `;
        },
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: true,
        width: 90,
        textAlign: 'center',
    },
]